// Calcule la profondeur maximale de la hiérarchie
export const getMaxDepth = (columnsDisposition) => {
  if (!columnsDisposition || columnsDisposition.length === 0) return 1;

  const calculateDepth = (columns) => {
    return columns.reduce((maxDepth, col) => {
      if (col.children) {
        return Math.max(maxDepth, 1 + calculateDepth(col.children));
      }
      return Math.max(maxDepth, 1);
    }, 0);
  };

  return calculateDepth(columnsDisposition);
};

// Compte le nombre de colonnes feuilles (enfants) d'une colonne
export const countLeafColumns = (column) => {
  if (!column.children) return 1;
  return column.children.reduce((count, child) => count + countLeafColumns(child), 0);
};

export const getLeafColumnsCount = (columnsDisposition = []) => {
  return columnsDisposition.reduce((count, column) => count + countLeafColumns(column), 0);
};

// Génère les lignes de headers hiérarchiques
export const buildHeaderRows = (columnsDisposition, columns, maxDepth) => {
  const rows = Array.from({ length: maxDepth }, () => []);
  const leafIndex = { value: 0 }; // Partagé entre toutes les colonnes
  const totalLeafColumns = columns.length;

  const processColumn = (column, depth = 0) => {
    if (column.children) {
      // Colonne parent
      const startLeafIndex = leafIndex.value;
      const leafCount = countLeafColumns(column);
      const lastLeafIndex = startLeafIndex + leafCount - 1;
      const isLastColumn = lastLeafIndex === totalLeafColumns - 1;

      rows[depth].push({
        key: column.key,
        title: column.title,
        colSpan: countLeafColumns(column),
        rowSpan: 1,
        isParent: true,
        isLastColumn,
      });

      column.children.forEach(child => processColumn(child, depth + 1));
    } else {
      // Colonne feuille - trouver la colonne correspondante dans columns
      const col = columns.find(c => c.key === column.key);
      if (col) {
        const isLastColumn = leafIndex.value === totalLeafColumns - 1;
        rows[depth].push({
          key: column.key,
          title: col.title,
          colSpan: 1,
          rowSpan: maxDepth - depth,
          isParent: false,
          columnData: col,
          leafIndex: leafIndex.value,
          isLastColumn,
        });
        leafIndex.value++;
      }
    }
  };

  columnsDisposition.forEach(column => processColumn(column, 0));

  return rows;
};
